module.exports = __webpack_public_path__ + "static/velkomin-i-biosal-kall-aa8e384d196888a457872a6cba3747f5.png";